var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey2Fill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9695 17.8482L27.8795 5.93823L31.0616 9.12021L28.9403 11.2415L32.1223 14.4235L26.8189 19.7268L23.6369 16.5449L19.1515 21.0302C20.6273 23.8577 20.1779 27.4284 17.8033 29.8031C14.8744 32.732 10.1256 32.732 7.19671 29.8031C4.26776 26.8742 4.26776 22.1253 7.19671 19.1964C9.57133 16.8218 13.1421 16.3724 15.9695 17.8482ZM14.6213 26.6211C15.793 25.4495 15.793 23.55 14.6213 22.3784C13.4497 21.2069 11.5503 21.2069 10.3787 22.3784C9.20711 23.55 9.20711 25.4495 10.3787 26.6211C11.5503 27.7926 13.4497 27.7926 14.6213 26.6211Z",
    fill: "#005F73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey2Fill);
export default __webpack_public_path__ + "static/media/key-2-fill.79d06dd3e0e57de33815ab3ca0caf2b0.svg";
export { ForwardRef as ReactComponent };